<!--Body-->
<img *ngIf="showEditButton" class="right floated pen-icon" appIcon="PenSolid" (click)="onEdit()" />
<h2 *ngIf="showTitle" class="ui left floated header">{{ 'applicant-tracker.applicants.hiringTeam' | translate }}</h2>
<div class="clear-both"></div>

<ng-container *ngFor="let hiringTeamLevel of hiringTeam">
    <h4>{{ hiringTeamLevel.accessLevel | translate }} {{ 'applicant-tracker.access' | translate }}</h4>

    <mat-divider></mat-divider>

    <app-avatar
        class="hiring-team-list-avatar"
        *ngFor="let employee of hiringTeamLevel.employees"
        [employee]="employee"
        [name]="true"
    ></app-avatar>
</ng-container>

<p *ngIf="!hiringTeam?.length">{{ noEmployeeMessage | translate }}</p>
